import Controller from '../abstracts/Controller';
import 'scss-templates/t-homepage.scss';

export default class HomepageController extends Controller {
  static get COMPONENTS() {
    return [
      'ActiveFiltersComponent',
      'DropdownComponent',
      'EditorialCoverInfiniteComponent',
      'EditorialCoverInfiniteComponent',
      'EditorialProductsSliderComponent',
      'FiltersComponent',
      'HeroComponent',
      'InfoBoxCarouselComponent',
      'LevelContentCarouselComponent',
      'ListingCarouselComponent',
      'ListingEditorialComponent',
      'ManifestoComponent',
      'ManifestoComponent',
      'PriceRangeComponent',
      'RecommendationEngineComponent',
      'SaleRangeComponent',
      'SalesScrollbarComponent',
      'SearchComponent',
      'ShortcutComponent',
      'ShortcutImageComponent',
      'LevelContentCarouselComponent',
      'DropdownComponent',
      'InfoBoxCarouselComponent',
      'EditorialProductsSliderComponent',
      'DoubleLaunchComponent',
      'GoogleRecommendationEngineComponent'
    ];
  }
}
